<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">描述管理</h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.desc_name" placeholder="请输入描述名称" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="success" size="large" @click="openAddDialog" style="float: right">
          <el-icon>
            <Plus />
          </el-icon>
          新增描述
        </el-button>


      </div>

      <!-- 描述列表 -->
      <el-table :data="titleList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column prop="desc_name" label="描述名称" width="180" />
        <el-table-column prop="desc_type" label="写作类型" width="120">
          <template #default="{ row }">
            <el-tag :type="row.desc_type === 1 ? 'primary' : 'success'">
              {{ row.desc_type === 1 ? '手动导入' : 'AI生成' }}
            </el-tag>
          </template>
        </el-table-column>


        <el-table-column prop="desc_keyword" label="描述关键词" width="180">
          <template #default="{ row }">
            <span v-if="row.desc_type === 2">{{ row.desc_keyword }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="desc_limit" label="生成上限" width="120">
          <template #default="{ row }">
            <span v-if="row.desc_type === 2">{{ row.desc_limit }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <!-- 新增两个表头列 -->
        <el-table-column label="描述列表" width="150" fixed="right">
          <template #default="scope">
            <el-button type="info" size="small" @click="openTitleListDialog(scope.row)">
              <el-icon>
                <View />
              </el-icon>
              查看描述
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="AI生成" width="150" fixed="right">
          <template #default="scope">
            <el-button v-if="scope.row.desc_type === 2" type="primary" size="small"
              @click="openAICreateDialog(scope.row)">
              <el-icon>
                <MagicStick />
              </el-icon>
              查看AI生成
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="备注" width="150" />
        <el-table-column prop="create_time" label="创建时间" width="180" />
        <el-table-column prop="update_time" label="更新时间" width="180" />

        <el-table-column label="操作" width="180" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
              <el-icon>
                <Edit />
              </el-icon>
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
              <el-icon>
                <Delete />
              </el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchTitleList" @current-change="fetchTitleList" />
      </div>
    </div>

    <!-- 新增查看描述对话框 -->
    <el-dialog v-model="titleListDialogVisible" :title="titleListDialogTitle" width="60%" top="5vh"
      :close-on-click-modal="false">
      <!-- 根据写作类型显示不同组件 -->
      <TitleAiCrateView v-if="titleListDialogVisible && currentTitleType === 2" :title-id="currentTitleId"
        :store-id="userInfo.id" />
      <TitleListView v-else-if="titleListDialogVisible" :title-id="currentTitleId" :store-id="userInfo.id" />
    </el-dialog>
    <!-- 新增查看AI生成对话框 -->
    <el-dialog v-model="aiCreateDialogVisible" :title="aiCreateDialogTitle" width="60%" top="5vh"
      :close-on-click-modal="false">
      <!-- 这里放置AI生成内容 -->
      <AICreateView v-if="aiCreateDialogVisible" :title-id="currentTitleId" :store-id="userInfo.id" />
    </el-dialog>
    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">
      <el-form ref="titleForm" :model="titleForm" label-width="120px" :rules="formRules">
        <el-form-item label="描述名称" prop="desc_name">
          <el-input v-model="titleForm.desc_name" placeholder="请输入描述名称" size="large" />
        </el-form-item>

        <el-form-item label="写作类型" prop="desc_type">
          <el-radio-group v-model="titleForm.desc_type" @change="handleTypeChange">
            <el-radio :label="1">手动导入</el-radio>
            <el-radio :label="2">AI生成</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 是否润色 - 只在手动导入时显示 -->
        <el-form-item label="是否润色" prop="polish_open" v-if="titleForm.desc_type === 1">
          <el-radio-group v-model="titleForm.polish_open">
            <el-radio :label="1">润色</el-radio>
            <el-radio :label="0">不润色</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 描述接口选择器 - 只在AI生成时显示 -->
        <el-form-item label="描述接口" prop="desc_model_id" v-if="titleForm.desc_type === 2">
          <el-select v-model="titleForm.desc_model_id" placeholder="请选择描述接口" filterable clearable style="width: 100%"
            :loading="loadingModels">
            <el-option label="不选择" :value="-1" />
            <el-option v-for="model in modelList" :key="model.id" :label="model.writing_name" :value="model.id" />
          </el-select>
        </el-form-item>

        <!-- 描述指令选择器 - 只在AI生成时显示 -->
        <el-form-item label="描述指令" prop="desc_instruct_id" v-if="titleForm.desc_type === 2">
          <el-select v-model="titleForm.desc_instruct_id" placeholder="请选择描述指令" filterable clearable
            style="width: 100%" :loading="loadingInstructs">
            <el-option label="不选择" :value="-1" />
            <!-- 修改2：使用 id 而不是 instruct_id -->
            <el-option v-for="instruct in instructList" :key="instruct.id" :label="instruct.instruct_name"
              :value="instruct.id" />
          </el-select>
        </el-form-item>


        <!-- 描述关键词 - 只在AI生成时显示 -->
        <el-form-item label="描述关键词" prop="desc_keyword" v-if="titleForm.desc_type === 2">
          <el-input v-model="titleForm.desc_keyword" type="textarea" :rows="3" placeholder="请输入描述关键词, 多个关键词用逗号分割！"
            size="large" />

          <!-- 增加分隔符按钮 -->
          <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
            <el-button type="primary" plain size="small" @click="addSeparator">
              <el-icon>
                <Plus />
              </el-icon>
              增加分隔符
            </el-button>
          </div>
        </el-form-item>

        <!-- 修改2：只在AI生成时显示生成上限 -->
        <el-form-item label="生成上限" prop="desc_limit" v-if="titleForm.desc_type === 2">
          <el-input v-model="titleForm.desc_limit" placeholder="请输入生成上限" size="large" />
        </el-form-item>


        <el-form-item label="备注信息">
          <el-input v-model="titleForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTitleForm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Plus, Edit, Delete, View, MagicStick
} from '@element-plus/icons-vue'
import TitleListView from '@/components/DescListView.vue'
import AICreateView from '@/components/DAICreateView.vue'
import TitleAiCrateView from '@/components/DescAiCrateView.vue'

export default {
  name: 'SeoconfigDesc',
  components: { Search, Plus, Edit, Delete, View, MagicStick, TitleListView, AICreateView, TitleAiCrateView },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增描述',
      isEditMode: false,
      instructList: [], // 存储描述指令列表
      loadingInstructs: false, // 指令加载状态
      searchForm: {
        desc_name: ''
      },
      titleForm: {
        id: null,
        desc_type: 1,
        desc_name: '',
        desc_keyword: '',
        desc_limit: '',
        notes: '',
        desc_model_id: null, // 新增字段
        desc_instruct_id: null, // 新增字段
        polish_open: 1 // 新增字段，默认1（润色）


      },
      formRules: {
        desc_name: [
          { required: true, message: '请输入描述名称', trigger: 'blur' }
        ],
        desc_instruct_id: [
          { required: false, message: '请选择描述指令', trigger: 'change' }
        ],
        desc_type: [
          { required: true, message: '请选择写作类型', trigger: 'change' }
        ],
        desc_model_id: [
          { required: false, message: '请选择描述接口', trigger: 'change' } // 初始设为非必须
        ],
        desc_keyword: [
          { required: false, message: '请输入描述关键词', trigger: 'blur' } // 初始设为非必须
        ],
        desc_limit: [
          { required: false, message: '请输入生成上限', trigger: 'blur' }
        ]
      },
      titleList: [],
      modelList: [], // 存储描述模型列表
      loadingModels: false, // 模型加载状态
      titleListDialogVisible: false,
      aiCreateDialogVisible: false,
      titleListDialogTitle: '',
      aiCreateDialogTitle: '',
      currentTitleId: null,
      currentTitleType: 1,// 1-手动导入 2-AI生成
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  mounted() {
    this.fetchTitleList();
    this.fetchModelList(); // 新增
    this.fetchInstructList(); // 新增


  },
  methods: {
    handleTypeChange() {
      const isAIType = this.titleForm.desc_type === 2;

      // 如果是AI生成类型，强制设置润色为1
      if (isAIType) {
        this.titleForm.polish_open = 1;
      }

      this.formRules.desc_model_id[0].required = isAIType;
      this.formRules.desc_keyword[0].required = isAIType;
      this.formRules.desc_instruct_id[0].required = isAIType; // 新增


      // 清除字段验证状态
      this.$nextTick(() => {
        this.$refs.titleForm.clearValidate(['desc_model_id', 'desc_keyword']);
      });
    },

    async fetchInstructList() {
      this.loadingInstructs = true;
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/CreationInstructionsController.php`,
          {
            action: 'list_all',
            store_id: this.userInfo.id
          }
        );

        if (data.data) {
          // 修改1：比较数字类型而不是字符串
          this.instructList = data.data.filter(instruct => instruct.instruct_type === 1);
          console.log('筛选后的指令列表:', this.instructList); // 调试用
        }
      } catch (error) {
        this.$message.error('获取描述指令失败');
        console.error('获取描述指令错误:', error);
      } finally {
        this.loadingInstructs = false;
      }
    },

    async fetchModelList() {
      this.loadingModels = true;
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/WritingModelKeyController.php`,
          {
            action: 'list_all',
            store_id: this.userInfo.id
          }
        );

        if (data.data) {
          // 筛选 writing_type 为 "2" 的数据
          this.modelList = data.data.filter(model => model.writing_type === "1");
        }
      } catch (error) {
        this.$message.error('获取描述模型失败');
        console.error('获取描述模型错误:', error);
      } finally {
        this.loadingModels = false;
      }
    },



    addSeparator() {
      // 如果当前输入不为空且最后不是逗号，则在末尾添加逗号
      if (this.titleForm.desc_keyword &&
        !this.titleForm.desc_keyword.trim().endsWith(',')) {
        this.titleForm.desc_keyword += ',';
      } else if (!this.titleForm.desc_keyword) {
        // 如果当前为空，则只添加逗号
        this.titleForm.desc_keyword = ',';
      }
    },
    // 获取描述列表
    async fetchTitleList() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.desc_name ? 'search' : 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        // 如果有搜索条件，加入搜索参数
        if (this.searchForm.desc_name) {
          params.desc_name = this.searchForm.desc_name;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/desc_management.php`,
          params
        );

        if (data.data) {
          this.titleList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取描述列表失败');
        console.error('获取描述列表错误:', error);
      } finally {
        this.loading = false;
      }
    },
    // 打开描述列表对话框
    openTitleListDialog(row) {
      this.currentTitleId = row.id;
      this.currentTitleType = row.desc_type; // 保存当前描述的写作类型
      this.titleListDialogTitle = `${row.desc_name} - 描述列表`;
      this.titleListDialogVisible = true;
    },

    // 打开AI生成对话框
    openAICreateDialog(row) {
      this.currentTitleId = row.id;
      this.aiCreateDialogTitle = `${row.desc_name} - AI生成记录`;
      this.aiCreateDialogVisible = true;
    },
    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchTitleList();
    },

    openAddDialog() {
      this.dialogTitle = '新增描述';
      this.isEditMode = false;
      this.titleForm = {
        id: null,
        desc_type: 1,
        desc_name: '',
        desc_keyword: '',
        desc_limit: '',
        notes: '',
        desc_model_id: null,
        polish_open: 1 // 新增，默认为1

      };
      this.dialogVisible = true;
    },

    openEditDialog(row) {
      this.dialogTitle = '编辑描述';
      this.isEditMode = true;
      this.titleForm = {
        id: row.id,
        desc_type: row.desc_type,
        desc_name: row.desc_name,
        desc_keyword: row.desc_type === 2 ? row.desc_keyword : '', // 只在AI生成时保留值
        desc_limit: row.desc_limit,
        notes: row.notes,
        desc_model_id: row.desc_type === 2 ? row.desc_model_id : null, // 只在AI生成时保留值
        desc_instruct_id: row.desc_type === 2 ? row.desc_instruct_id : null, // 新增
        polish_open: row.polish_open ?? 1 // 新增，默认为1

      };
      this.dialogVisible = true;
    },

    // 提交表单（新增/编辑）
    submitTitleForm() {

      this.handleTypeChange();

      this.$refs.titleForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add';
            const payload = {
              ...this.titleForm,
              store_id: this.userInfo.id
            };

            // 如果是手动导入，清除AI相关字段
            if (this.titleForm.desc_type === 1) {
              payload.desc_keyword = '';
              payload.desc_model_id = 0;
              payload.desc_instruct_id = 0; // 新增

            }
            if (this.titleForm.desc_type === 2) {
              this.titleForm.polish_open = 1;
            }
            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/desc_management.php`,
              {
                action,
                ...payload
              }
            );

            if (data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchTitleList();
            } else {
              this.$message.error(data.error || '操作失败');
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '操作失败';
            this.$message.error(`操作失败: ${errorMsg}`);
            console.error('表单提交错误:', error);
          }
        }
      });
    },

    // 删除描述
    async handleDelete(id) {
      this.$confirm('确定要删除该描述配置吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/desc_management.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.id
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchTitleList();
          } else {
            this.$message.error(data.error || '删除失败');
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '删除失败';
          this.$message.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 0px;
}

.settings-form {
  max-width: 95%;
  margin: 0 auto;
  padding: 32px 40px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.page-title {
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 32px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* 表格样式优化 */
.el-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  :deep(.el-table__header) th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
  }

  :deep(.el-table__body) tr:hover>td {
    background-color: #f0f7ff !important;
  }
}

/* 操作按钮样式 */
.el-button {
  display: inline-flex;
  align-items: center;

  .el-icon {
    margin-right: 5px;
  }
}

/* 对话框样式优化 */
:deep(.el-dialog) {
  border-radius: 12px;

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #ebeef5;
    margin-right: 0;

    .el-dialog__title {
      font-weight: 600;
      color: #1f2937;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #ebeef5;
  }
}

/* 表单验证提示样式 */
:deep(.el-form-item__error) {
  font-size: 12px;
  padding-top: 4px;
}
</style>